import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';

const AdminLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!authService.isAuthenticated()) {
            navigate('/admin/login');
        }
    }, [navigate]);

    const handleLogout = () => {
        authService.logout();
        navigate('/admin/login');
    };

    // Menu items
    const menuItems = [
        { id: 'dashboard', label: 'Dashboard', icon: '📊', path: '/admin/dashboard' },
        { id: 'blogs', label: 'Blogs', icon: '📝', path: '/admin/blogs' },
        { id: 'instagram', label: 'Instagram', icon: '📸', path: '/admin/instagram' },
        { id: 'settings', label: 'Settings', icon: '⚙️', path: '/admin/settings' }
    ];

    const currentMenuItem = menuItems.find(item => location.pathname === item.path);

    const sidebarStyle = {
        width: sidebarOpen ? '280px' : '80px',
        minWidth: sidebarOpen ? '280px' : '80px',
        height: '100vh',
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)',
        borderRight: '1px solid rgba(201, 169, 110, 0.2)',
        transition: 'all 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        left: 0,
        top: 0,
        zIndex: 100,
        overflow: 'hidden'
    };

    const mainContentStyle = {
        marginLeft: sidebarOpen ? '280px' : '80px',
        width: '100%',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        transition: 'margin-left 0.3s ease',
        overflow: 'hidden'
    };

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#0F0F0F' }}>
            {/* Sidebar */}
            <aside style={sidebarStyle}>
                {/* Logo & Toggle */}
                <div style={{
                    padding: '30px 20px',
                    borderBottom: '1px solid rgba(201, 169, 110, 0.2)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: '100px'
                }}>
                    {sidebarOpen ? (
                        <>
                            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                <img src={`${process.env.PUBLIC_URL}/current-logo.png`} alt="Logo" style={{ height: '40px' }} />
                            </div>
                            <button
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: 'var(--accent-color)',
                                    cursor: 'pointer',
                                    fontSize: '20px',
                                    padding: '5px'
                                }}
                            >
                                ☰
                            </button>
                        </>
                    ) : (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <img src={`${process.env.PUBLIC_URL}/current-logo.png`} alt="Logo" style={{ height: '40px' }} />
                        </div>
                    )}
                </div>

               

                {/* User Info & Logout */}
                <div style={{
                    padding: '20px',
                    borderTop: '1px solid rgba(201, 169, 110, 0.2)'
                }}>
                    {sidebarOpen ? (
                        <div>
                                 {/* Menu Items */}
                <div style={{ 
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                    marginTop: '20px',
                    marginBottom: '20px'
                }}>
                    {menuItems.map(item => {
                        const isActive = location.pathname === item.path;
                        return (
                            <Link
                                key={item.id}
                                to={item.path}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '12px 16px',
                                    background: isActive ? 'rgba(201, 169, 110, 0.15)' : 'transparent',
                                    borderLeft: isActive ? '4px solid var(--accent-color)' : '4px solid transparent',
                                    borderRadius: '8px',
                                    color: isActive ? 'var(--accent-color)' : 'rgba(245, 241, 237, 0.7)',
                                    fontSize: '15px',
                                    fontWeight: isActive ? '600' : '400',
                                    textDecoration: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    if (!isActive) {
                                        e.currentTarget.style.background = 'rgba(201, 169, 110, 0.08)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isActive) {
                                        e.currentTarget.style.background = 'transparent';
                                    }
                                }}
                            >
                                <span style={{ fontSize: '20px', flexShrink: 0 }}>{item.icon}</span>
                                {sidebarOpen && <span style={{ whiteSpace: 'nowrap' }}>{item.label}</span>}
                            </Link>
                        );
                    })}
                </div>
                <button
                    onClick={handleLogout}
                    style={{
                        width: '100%',
                        padding: '12px',
                        background: 'rgba(230, 57, 70, 0.15)',
                        border: '1px solid rgba(230, 57, 70, 0.3)',
                        borderRadius: '8px',
                        color: '#E63946',
                        fontSize: '14px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '8px',
                        marginTop: '10px'
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(230, 57, 70, 0.25)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(230, 57, 70, 0.15)';
                    }}
                >
                    🚪 Logout
                </button>
            </div>
                    ) : (
                        <button
                            onClick={handleLogout}
                            style={{
                                width: '100%',
                                padding: '12px',
                                background: 'rgba(230, 57, 70, 0.15)',
                                border: '1px solid rgba(230, 57, 70, 0.3)',
                                borderRadius: '8px',
                                color: '#E63946',
                                fontSize: '20px',
                                cursor: 'pointer'
                            }}
                        >
                            🚪
                        </button>
                    )}
                </div>
            </aside>

            {/* Main Content */}
            <main style={mainContentStyle}>
                {/* Top Header */}
                <header style={{
                    background: '#1a1a1a',
                    borderBottom: '1px solid rgba(201, 169, 110, 0.2)',
                    padding: '20px 40px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    minHeight: '80px'
                }}>
                
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                        <button
                            style={{
                                padding: '10px 20px',
                                background: 'linear-gradient(135deg, var(--accent-color) 0%, #B8935D 100%)',
                                border: 'none',
                                borderRadius: '8px',
                                color: '#000',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                transition: 'all 0.3s ease'
                            }}
                            onClick={() => window.open('/', '_blank')}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(201, 169, 110, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = 'none';
                            }}
                        >
                            🌐 View Website
                        </button>
                    </div>
                </header>

                {/* Content Area */}
                <div style={{
                    flex: 1,
                    overflowY: 'auto',
                    padding: '40px',
                    background: '#0F0F0F'
                }}>
                    {children}
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
